'use client'

import { cn } from '@/lib/utils'
import Tooltip from '../shared/Tooltip'

type UntradableIndicatorProps = {
	className?: string
}

export function UntradableIndicator({ className }: UntradableIndicatorProps) {
	return (
		<Tooltip content="Contains markets not available for onchain trading">
			<span
				className={cn(
					'inline-flex h-2 w-2 items-center justify-center rounded-full bg-red-500',
					'cursor-help',
					className
				)}
			/>
		</Tooltip>
	)
}
